/**
 * @copyright 2023 Honda Motor Co., Ltd. All rights reserved.
 */

import { GetTaskRequest, TasksApi } from "client";
import { Const } from "const";
import { useApiWithTimeout } from "./ApiWrapperWithTimeout";
import { useState } from "react";
import { useCallApi } from "./CallApiHook";

export const useGetTask = () => {
  const [getTasksApi, cancelGetTasksApi] = useApiWithTimeout(
    TasksApi,
    Const.operationTimeout.getTask
  );
  const [request, setRequest] = useState<GetTaskRequest>();

  const result = useCallApi(
    async () => {
      if (request) {
        const resultTask = await getTasksApi.getTask(request);
        if (resultTask === undefined) {
          return {};
        }
        return resultTask;
      }
    },
    cancelGetTasksApi,
    [getTasksApi, cancelGetTasksApi, request]
  );
  return { ...result, setRequest };
};
